import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var HairTestReportRes;
export const HairTestReportTodo = createAsyncThunk('HairTestReport', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'admin/hair_analytics',
            data: {
                'hair_sample_location': data.hair_location,
                'fungal_type': data.fungal_typ,
                'structure_type': data.structure_typ,
                'metal_type': data.metal_typ,
                'metal_concentration': parseFloat(data.metal_concetration),
                'keratin_presence': parseInt(data.keratin_presence),
                'protein_level': parseFloat(data.protein_level),
                'hair_color': data.hair_color,
                'abnormal_structure_presence': parseInt(data.asp),
                'heavy_metals_presence': parseInt(data.hmp),
                "company_id":localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json", }
        })
        return HairTestReportRes = res.data

    } catch (error) {
        return HairTestReportRes = error.response.data
    }
})